"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNftSaleConfigsSortToJSON = exports.GetNftSaleConfigsSortFromJSONTyped = exports.GetNftSaleConfigsSortFromJSON = exports.GetNftSaleConfigsSort = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var GetNftSaleConfigsSort;
(function (GetNftSaleConfigsSort) {
    GetNftSaleConfigsSort["SortPriority"] = "sortPriority";
    GetNftSaleConfigsSort["CreatedAt"] = "createdAt";
})(GetNftSaleConfigsSort = exports.GetNftSaleConfigsSort || (exports.GetNftSaleConfigsSort = {}));
function GetNftSaleConfigsSortFromJSON(json) {
    return GetNftSaleConfigsSortFromJSONTyped(json, false);
}
exports.GetNftSaleConfigsSortFromJSON = GetNftSaleConfigsSortFromJSON;
function GetNftSaleConfigsSortFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GetNftSaleConfigsSortFromJSONTyped = GetNftSaleConfigsSortFromJSONTyped;
function GetNftSaleConfigsSortToJSON(value) {
    return value;
}
exports.GetNftSaleConfigsSortToJSON = GetNftSaleConfigsSortToJSON;
